import axios from 'axios';

export const fetchMenus = (venueId, apiUrl, subscriptionKey) => {
  return axios({
    url: `${apiUrl}/${venueId}`,
    timeout: 20000,
    method: 'GET',
    headers: {
      'Ocp-Apim-Subscription-Key': subscriptionKey,
    },
  });
};
